export { default } from './QuantityTotal'
